import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { signOut } from "firebase/auth";

import { useAuth } from "../contextos/AuthContext";
import { db, auth } from "../firebase/firebaseConfig";
import { cargarGruposProfesor, crearGrupo } from "../funciones/gruposServicio";

import DashboardProfesor from "./dashboard_profesor/DashboardProfesor";

const ProfesorHome = () => {
  const { usuario } = useAuth();
  const navigate = useNavigate();

  const [datosUsuario, setDatosUsuario] = useState(null);
  const [grupos, setGrupos] = useState([]);

  const cerrarSesion = async () => {
    await signOut(auth);
    navigate("/");
  };

  const cambiarPerfil = async (perfil) => {
    await updateDoc(doc(db, "usuarios", usuario.uid), { perfilActivo: perfil });
    navigate(0);
  };

  const cargarGrupos = useCallback(async () => {
    if (!usuario) return;
    try {
      setGrupos(await cargarGruposProfesor(usuario.uid));
    } catch (err) {
      console.error("Error cargando grupos:", err);
    }
  }, [usuario]);

  const guardarGrupo = async (datos) => {
    await crearGrupo(datos, usuario.uid);
    await cargarGrupos();
  };

  useEffect(() => {
    if (!usuario) return;

    const cargar = async () => {
      const snap = await getDoc(doc(db, "usuarios", usuario.uid));
      if (snap.exists()) setDatosUsuario(snap.data());
      await cargarGrupos();
    };

    cargar();
  }, [usuario, cargarGrupos]);

  if (!datosUsuario) return null;

  return (
    <DashboardProfesor
      usuario={datosUsuario}
      grupos={grupos}
      perfilActivo={datosUsuario.perfilActivo}
      onCambiarPerfil={cambiarPerfil}
      onCrearGrupo={guardarGrupo}
      onVerGrupos={(grupoId) => {
        if (grupoId) {
          navigate(`/profesor/grupos/${grupoId}`);
          return;
        }
        navigate("/profesor/grupos");
      }}
      onCerrarSesion={cerrarSesion}
    />
  );
};

export default ProfesorHome;